import {type UIChild, UI} from "../../../stem-core/ui/UIBase";

import {BasePanelPage} from "../PanelPage.jsx";
import {AuthFlowPanel} from "../../common/auth/AuthFlowPanel.jsx";


export class AuthPanelPage extends BasePanelPage {
    getFlowOptions(): any {}

    render(): UIChild {
        return <AuthFlowPanel {...this.getFlowOptions()} />
    }
}
